import { useTranslation } from "react-i18next";
import { FaExclamationTriangle } from "react-icons/fa";
import { Card } from "@/components/ui/card";

interface HomeAtRiskAlertProps {
  needed: number;
  going: number;
  min: number;
}

export function HomeAtRiskAlert({ needed, going, min }: HomeAtRiskAlertProps) {
  const { t } = useTranslation();

  return (
    <Card
      role="alert"
      hoverable={false}
      className="flex items-start gap-3 border-destructive/60 bg-destructive/10 p-4"
    >
      <FaExclamationTriangle className="mt-0.5 shrink-0 text-destructive" />
      <div className="space-y-0.5">
        <p className="text-sm font-bold text-destructive">
          {t("v2.home.dropBelowMinTitle")}
        </p>
        <p className="text-sm text-muted-foreground">
          {t("v2.home.dropBelowMinDesc", { needed, going, min })}
        </p>
      </div>
    </Card>
  );
}
